/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */

export class UOfMeasure {
  id: number;
  name: string;
  type: UOfMeasure_type;
  isEnabled: boolean;

  constructor(i = 0) {
    this.id = 0;
    this.name = "";
    this.type = UOfMeasure_type.standard;
    this.isEnabled = true;
  }
}

export enum UOfMeasure_type {
  standard = "Standard",
  user_defined = "User-defined",
}

/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */
